export default "__VITE_ASSET__d6e86094__"